import { styled } from '@mui/material';
import LargeMuiButton from 'src/components/common/Buttons/LargeMuiButton';
import colors from 'src/utils/colors';

export const SaveButton = styled(LargeMuiButton)(() => ({
  height: '40px',
  color: 'white',
  lineHeight: 'normal',
  borderRadius: '23px',
  backgroundColor: colors.darkBlue,
  textTransform: 'none',
  width: '95%',
  ':hover': {
    backgroundColor: colors.darkBlue,
    opacity: '90%'
  }
}));

export const BulkUploadButton = styled(SaveButton)(() => ({
  backgroundColor: '#46a7f5',
  '&:hover': {
    backgroundColor: '#46a7f5',
    opacity: '90%'
  }
}));

export const ClearFiltersButton = styled(SaveButton)(() => ({
  color: colors.darkBlue,
  border: `1px solid ${colors.darkBlue}`,
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent',
    opacity: '90%'
  }
}));
